export default {
    data() {
        return {
            typeEchangeurInterventionConst: [
                {label: this.$t('type_echangeur.numero'), value: 'NUMERO'},
                {label: this.$t('type_echangeur.bretelle'), value: 'BRETELLE'},
            ],
        }
    },
    methods: {
        displayForTypeEchangeurInterventionConst(value) {
            let result = this.typeEchangeurInterventionConst.find(el => el.value === value);
            return result ? result.label : '';
        },
        getTypeEchangeurInterventionConst() {
            return this.typeEchangeurInterventionConst;
        }
    }
}